import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from './truncate.pipe';
import { QmRoundPipe } from './qm-round.pipe';
import { QmMapValuesPipe } from './qm-map-values.pipe';
import { QmCapitalizePipe } from './qm-capitalize.pipe';
import { QmDateFormatPipe } from './qm-date-format.pipe';
import { QmDateDiffPipe } from './qm-date-diff.pipe';
import { QmDateDistancePipe } from './qm-date-distance.pipe';
import { QmLinkPipe } from './qm-link.pipe';
import { QmReplacePipe } from './qm-replace.pipe';
import { QmTableFilterPipe } from './qm-table-filter.pipe';
import { ApplyFunctionPipe } from './apply-function-pipe/apply-function.pipe';
import { SafeUrlPipe } from './safe-url/safe-url.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [TruncatePipe, QmRoundPipe, QmMapValuesPipe, QmCapitalizePipe,
    QmDateFormatPipe, QmDateDiffPipe, QmDateDistancePipe, QmLinkPipe, QmReplacePipe, QmTableFilterPipe, ApplyFunctionPipe, SafeUrlPipe],
  exports: [TruncatePipe, QmRoundPipe, QmMapValuesPipe, QmCapitalizePipe, QmReplacePipe,
    QmDateFormatPipe, QmDateDiffPipe, QmDateDistancePipe, QmLinkPipe, QmTableFilterPipe, ApplyFunctionPipe, SafeUrlPipe]
})
export class QmPipesModule {
}
